import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Trans, useTranslation } from 'react-i18next';
import PreviewVideo from '../assets/Vorschau-wird-vorbereitet.webm';
import PreviewVideoMp4 from '../assets/Vorschau-wird-vorbereitet.mp4';
import { BodyText, H1 } from './ui/Typography';

interface PreparingWebsitePreviewProps {}

const PreparingWebsitePreview: React.FC<PreparingWebsitePreviewProps> =
  observer(() => {
    const { t } = useTranslation();

    return (
      <React.Fragment>
        <div className="animation holder flex flex-col items-center justify-center h-full">
          <div className="flex justify-center">
            <div className="w-[calc(100%-48px)] sm:w-[618px] bg-white p-[24px] overflow-hidden rounded-md mb-8 shadow-[0px_4px_8px_0px_rgba(0,0,0,0.05)]">
              <video
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                className="w-full h-full object-contain">
                <source src={PreviewVideo} type="video/webm" />
                <source src={PreviewVideoMp4} type="video/mp4" />
                {t('Your browser does not support the video tag.')}
              </video>
            </div>
          </div>
          <H1>{t('Your preview is currently being prepared')} </H1>

          <BodyText>
            <Trans i18nKey="preparing.paragraph">
              Our AI is currently generating your personalized{' '}
              <strong>website preview</strong>: text content is being created,
              and images are being selected based on your input. This process
              can take up to 10 minutes –{' '}
              <strong>please keep the browser window open.</strong>
            </Trans>
          </BodyText>
        </div>
      </React.Fragment>
    );
  });

export default PreparingWebsitePreview;
